export default __webpack_public_path__ + "static/Toyota_Desktop_Typography_Subhead_Leading-6cc0714e013b7955c491ed6dfa223e4a.svg";